/**
 * Cover ufficiali per i 6 comuni d'Ischia (Wikimedia Commons).
 * Usate da hero, ricerca e fallback finché Mongo non ha image/hero_image.
 */
export const ISCHIA_HERO_BY_SLUG = {
  ischia:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/Castello_Aragonese_%28Ischia%29.jpg/1280px-Castello_Aragonese_%28Ischia%29.jpg",
  "casamicciola-terme":
    "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8e/Ischia_harbour.jpg/1280px-Ischia_harbour.jpg",
  "lacco-ameno":
    "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Il_%22Fungo%22%2C_scoglio_di_Lacco_Ameno.jpg/1280px-Il_%22Fungo%22%2C_scoglio_di_Lacco_Ameno.jpg",
  forio:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Chiesa_del_Soccorso%2C_Forio.jpg/1280px-Chiesa_del_Soccorso%2C_Forio.jpg",
  "serrara-fontana":
    "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/Sant%27Angelo_%28Ischia%29_01.jpg/1280px-Sant%27Angelo_%28Ischia%29_01.jpg",
  "barano-d-ischia":
    "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a8/Maronti_Beach.jpg/1280px-Maronti_Beach.jpg",
};

export function ischiaHeroForSlug(slug) {
  const s = typeof slug === "string" ? slug.trim().toLowerCase() : "";
  return ISCHIA_HERO_BY_SLUG[s] || "";
}
